import React, { useState, useEffect } from 'react'
import { Table, Form, Flex, DatePicker, Space, Switch } from 'antd'
import classes from '../statistic.module.css'
import Icon from '../../cpn/Icon'
import { useDeptTJQuery } from '../../store/DianShangYeWuApi'
import dayjs from 'dayjs'
import DeptGroupDetails from './DeptGroupDetails'
function StatisticProfitDept(props) {
    const [form] = Form.useForm();
    const getDefaultQuery = () => {
        const s = localStorage.getItem('jtg-caiwu_statistic_profit_dept_date_s') || '';
        const e = localStorage.getItem('jtg-caiwu_statistic_profit_dept_date_e') || '';
        if (s && e) return { date_s: s, date_e: e, num: false };
        const start = dayjs().startOf('month').format('YYYY-MM-DD');
        const end = dayjs().endOf('month').format('YYYY-MM-DD');
        return { date_s: start, date_e: end, num: false };
    };
    const [query, setQuery] = useState(getDefaultQuery());
    const [list, setList] = useState([]);
    const {data,isSuccess} = useDeptTJQuery({d_qy_id:props.qy_id,date_s:query.date_s,date_e:query.date_e}, { refetchOnMountOrArgChange: true,skip:query.date_s==='' || query.date_e===''});
    const columns = [        
        {
            title: '部门名称（点击查看明细）',
            dataIndex: 'd_name',
            key: 'd_name',
            render: (text, record) => <DeptGroupDetails 
                                          dept_id={record.d_id}
                                          date_s={query.date_s}
                                          date_e={query.date_e}
                                          qy_id={props.qy_id}
                                          qy_name={props.qy_name}
                                          yh_id={props.yh_id}
                                          yh_name={props.yh_name}
                                          spjdList={props.spjdList}
                                          dept_name={record.d_name}
                                       />,
        },
        {
            title: '数量',
            dataIndex: 'dsbzd_num',
            key: 'dsbzd_num',
        },
        {
            title: '收入',
            dataIndex: 'ddsr_amount',
            key: 'ddsr_amount',
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '支出',
            dataIndex: 'ddzc_amount',
            key: 'ddzc_amount',
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '费用',
            dataIndex: 'fy_amount',
            key: 'fy_amount',
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '利润',
            dataIndex: 'd_profit',
            key: 'd_profit',
            render: (text, record) => <span style={{color:Number(record.ddsr_amount - record.ddzc_amount - record.fy_amount) > 0 ? 'red' : 'green'}}>￥{Number(record.ddsr_amount - record.ddzc_amount - record.fy_amount).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '利润率',
            dataIndex: 'd_profit_rate',
            key: 'd_profit_rate',
            render: (text, record) => {
                if(+record.ddsr_amount === 0 && +record.ddzc_amount === 0 && +record.fy_amount === 0){
                    return '0.00%';
                }else{
                    return Number((record.ddsr_amount - record.ddzc_amount - record.fy_amount) / record.ddsr_amount * 100).toFixed(2) + '%';
                }
            },
        },
        // {
        //     title: '应收款',
        //     dataIndex: 'd_ysk_amount',
        //     key: 'd_ysk_amount',
        //     render: (text, record) => <span>0.00</span>
        // },
        // {
        //     title: '应付款',
        //     dataIndex: 'd_yfk_amount',
        //     key: 'd_yfk_amount',   
        //     render: (text, record) => <span>0.00</span>
        // },
    ]
    useEffect(() => {
       if(isSuccess){
        if(data.Status==='success'){
            let list = data.Result;
            if(query.num){
                list = list.filter(item => item.dsbzd_num > 0);
            }
            setList(list);
        }
       }else{
        setList([]);
       }
    }, [isSuccess,data,query]);
    return (
        <>
            <Flex justify='flex-start'>
                <Form
                    layout='inline'
                    name='form_dept'
                    form={form}
                    onFinish={(values) => {
                        setQuery(prev => ({
                            ...prev,
                            date_s: values.date_range[0] ? dayjs(values.date_range[0]).format('YYYY-MM-DD') : '',
                            date_e: values.date_range[1] ? dayjs(values.date_range[1]).format('YYYY-MM-DD') : '',
                        }))
                        localStorage.setItem('jtg-caiwu_statistic_profit_dept_date_s', values.date_range[0] ? dayjs(values.date_range[0]).format('YYYY-MM-DD') : '')
                        localStorage.setItem('jtg-caiwu_statistic_profit_dept_date_e', values.date_range[1] ? dayjs(values.date_range[1]).format('YYYY-MM-DD') : '')
                    }}
                    initialValues={{
                        date_range: query.date_s && query.date_e
                            ? [dayjs(query.date_s), dayjs(query.date_e)]
                            : [dayjs().startOf('month'), dayjs().endOf('month')],
                        num: false,
                    }}
                >
                    <Form.Item name='date_range' label='起止日期' rules={[{ required: true, message: '请选择起止日期' }]}>
                        <DatePicker.RangePicker />
                    </Form.Item>
                    <Form.Item name='num' label='隐藏数量为0的部门'>
                        <Switch onChange={(e) => {
                            setQuery(prev => ({
                                ...prev,
                                num: e,
                            }));
                        }}>
                        </Switch>
                    </Form.Item>
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon 
                                type='search' 
                                onClick={() => form.submit()}
                            />
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    localStorage.removeItem('jtg-caiwu_statistic_profit_dept_date_s');
                                    localStorage.removeItem('jtg-caiwu_statistic_profit_dept_date_e');
                                    const def = getDefaultQuery();
                                    form.setFieldsValue({
                                        date_range: [dayjs(def.date_s), dayjs(def.date_e)],
                                        num: false,
                                    });
                                    setQuery(def);
                                    setList([]);
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                rowKey='d_id'
                bordered
                size='small'
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'10',
                    showTotal:(total) => `共${total}条`,
                }}
                className={classes.customTable}
                style={{marginTop:"10px"}}
                summary={pageData => {
                    const total_dsbzd_num = pageData.reduce((sum, row) => sum + Number(row.dsbzd_num || 0), 0);
                    const total_ddsr_amount = pageData.reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0);
                    const total_ddzc_amount = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);
                    const total_fy_amount = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);
                    const total_d_profit = Number(total_ddsr_amount - total_ddzc_amount - total_fy_amount).toFixed(2);
                    // 这里计算平均利润率
                    const count = pageData.length;
                    const total_d_profit_rate = count > 0 
                        ? pageData.reduce((sum, row) => sum + Number(row.d_profit_rate || 0), 0) / count
                        : 0;
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-1" index={0}>合计:</Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-3" index={1}>
                                <span>{total_dsbzd_num}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-4" index={2} colSpan={1}>
                                <span style={{color:'red'}}>￥{Number(total_ddsr_amount).toLocaleString('zh-CN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-5" index={3} colSpan={1}>
                            <span style={{color:'green'}}>￥{Number(total_ddzc_amount).toLocaleString('zh-CN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-6" index={4} colSpan={1}>  
                                <span style={{color:'blue'}}>￥{Number(total_fy_amount).toLocaleString('zh-CN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-7" index={5} colSpan={1}>
                                <span style={{color:Number(total_d_profit) > 0 ? 'red' : 'green'}}>￥{Number(total_d_profit).toLocaleString('zh-CN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-8" index={6} colSpan={1}>  
                                <span>{total_d_profit_rate.toFixed(2)}%</span>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }} 
            />
        </>
    )
}

export default StatisticProfitDept